// extracted by mini-css-extract-plugin
module.exports = {"label":"feed-info_label__3eMH- text text_type_main-medium","value":"feed-info_value__1hW61 text text_type_digits-large"};